import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useFormState } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link } from 'react-router-dom';

import AuthBackground from 'components/AuthBackground';
import Button from 'components/Button';
import Input from 'components/Input';
import { login as TEXT } from 'locales/en';
import { login, setNeedVerification } from 'redux/slices/auth';
import Verify from 'pages/SignUp/Verify.admin';

import PATHS from 'routes/paths';
import schema from './schema';

const Login = () => {
  const dispatch = useDispatch();
  const { needVerification, error } = useSelector((state) => state.auth);
  const { register, handleSubmit, control } = useForm({
    resolver: yupResolver(schema),
  });
  const { errors, isSubmitting } = useFormState({ control });

  const onSubmit = (data) => {
    return dispatch(login(data));
  };

  return needVerification ? (
    <Verify onClickReturn={() => dispatch(setNeedVerification(false))} />
  ) : (
    <AuthBackground
      header1={TEXT.header1}
      header2={TEXT.header2}
      canDisplayFlash={false}
    >
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between"
      >
        <div>
          <Input
            label={TEXT.email}
            name="email"
            type="email"
            register={register}
            required
            error={errors.email?.message}
          />
          <Input
            label={TEXT.password}
            name="password"
            type="password"
            register={register}
            required
            error={errors.password?.message}
            customError={
              error ? (
                <>
                  <span>{TEXT.notMatch}</span>
                  <Link className="underline" to={PATHS.forgotPassword}>
                    {TEXT.requestPassword}
                  </Link>
                </>
              ) : null
            }
          />
        </div>
        <div className="flex justify-between items-center mt-2">
          <Link
            to={PATHS.forgotPassword}
            className="text-sm text-javelin-blue-dark border-0 text-left focus:outline-none"
          >
            {TEXT.forgotPassword}
          </Link>
          <Button
            className="bg-javelin-blue-dark w-44 py-4 font-bold text-base rounded-full mt-2 col-start-2 md:col-start-3 px-4"
            type="submit"
            title={TEXT.submit}
            showSpinner={isSubmitting}
          />
        </div>
      </form>
    </AuthBackground>
  );
};

export default Login;
